import { createAsyncThunk } from '@reduxjs/toolkit';
import { StatusCodes } from 'http-status-codes';
import OperatorRegionalOfficeService from 'services/operatorRegionalOfficeService';

export const getAllOperatorRegionalOffice = createAsyncThunk(
  'operatorRegionalOffice/getAll',
  async (_, thunkAPI) => {
    try {
      const { status, data } = await OperatorRegionalOfficeService.getAllOperatorRegionalOffice();
      if (status === StatusCodes.OK) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e: any) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
